import { EventLog, useServerStat } from 'api'
import { calulateMountpointUptimeInfo, UptimeInfo } from 'dashboard/Util'
import { Item } from 'dashboard/LinkUptimeBarChart'
import ConnectionLogsPieChart from './ConnectionLogsPieChart'
import Typography from '@material-ui/core/Typography'
import { strings } from 'strings'
import Table, { Column } from 'common/Table'

interface Props {
  mountpointId: number
  mountpointName: string
  showDisconnects: boolean
  startDate: Date
  endDate: Date
}
const MountpointUptimeInfo = ({
  mountpointId,
  mountpointName,
  showDisconnects,
  startDate,
  endDate,
}: Props) => {
  const { serverStat } = useServerStat(mountpointName)

  if (!serverStat) return null

  const startDateSecs = startDate.getTime() / 1000
  const endDateSecs = endDate.getTime() / 1000

  const allLogs = JSON.parse(
    serverStat.mountpoints[mountpointName].eventLog,
  ) as EventLog[]

  const {
    onlineTotalSeconds,
    offlineTotalSeconds,
    disconnections,
    allConnections,
    onlinePercent,
  } = calulateMountpointUptimeInfo(
    allLogs,
    startDateSecs,
    endDateSecs,
    mountpointName,
  )

  const columns: Column<any>[] = [
    {
      id: 'duration',
      label: strings.range,
      path: 'duration',
      width: 150,
    },
    {
      id: 'end',
      label: strings.end,
      path: 'end',
      width: 175,
    },
    {
      id: 'start',
      label: strings.start,
      path: 'start',
      width: 175,
    },
  ]

  return (
    <div style={{ width: '100%' }}>
      {allLogs.length !== 0 ? (
        <>
          <ConnectionLogsPieChart
            onlineTotalSeconds={onlineTotalSeconds}
            offlineTotalSeconds={offlineTotalSeconds}
          />
          <Item
            mountpointId={mountpointId}
            mountpointName={mountpointName}
            allConnections={allConnections}
            disconnectionsCount={disconnections.length}
            onlinePercent={onlinePercent}
          />
          {showDisconnects && (
            <>
              <Typography style={{ marginTop: '1rem' }}>
                {strings.diconnectionsList}
              </Typography>
              <Table columns={columns} data={disconnections} />
            </>
          )}
        </>
      ) : (
        <Typography>{strings.dataNotFound}</Typography>
      )}
    </div>
  )
}

export default MountpointUptimeInfo
